module.exports = __webpack_public_path__ + "static/anything-you-want-3899621cabc612f0ee9e3047476bc299.jpg";